import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import "vant/es/popup/style";
import _Popup from "vant/es/popup"; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.filter.js";
import Vue from 'vue';
import Geo from 'drip/geo';
import Event from 'drip/event';
import Drip from 'drip';
import Store from 'drip/store';
import { getLionConfig } from '@/common/lionConfig';
// import dpCityMap from '@/common/dp-city-map.js'
Vue.use(_Popup);
export default {
  props: {
    isPopup: {
      type: Boolean,
      default: false
    },
    gCi: {
      type: Number | undefined,
      default: undefined
    }
  },
  data: function data() {
    return {
      show: false,
      cities: [],
      cityLetterMap: {},
      search: {
        key: '',
        result: null
      },
      mtCities: [],
      locationStatus: 0,
      locationText: {
        0: '定位中...',
        1: '定位失败'
      },
      history: [],
      locCity: {},
      isDpH5: ['dianping_chwl', 'dianping_m', 'dianping'].includes(Drip.constant.uaInfo.appName)
    };
  },
  components: {
    // Cities
  },
  computed: {
    hotCities: function hotCities() {
      return (this.cities || []).slice(0, 12);
    },
    localCityByMt: function localCityByMt() {
      var _this = this;
      // 许愿统一统计美团城市，点评需要将cityid转换成美团的
      if (this.isDpH5) {
        var _city = this.cities && this.cities.find(function (el) {
          return el.nm === _this.locCity.nm;
        });
        return _city || {
          id: 1,
          nm: '北京',
          py: 'beijing'
        };
      }
      // 避免knb只返回id，查询当前name
      var city = this.cities && this.cities.find(function (el) {
        return Number(el.id) === Number(_this.locCity.id);
      });
      return city || {
        id: 1,
        nm: '北京',
        py: 'beijing'
      };
    }
  },
  watch: {
    isPopup: function isPopup(value) {
      this.show = value;
      if (value) {
        var $anchor = document.getElementById('location');
        if ($anchor) {
          this.$nextTick(function () {
            $anchor.scrollIntoView();
          });
        }
      }
    }
  },
  created: function created() {
    this.handleCities();
    this.getLocation();
  },
  beforeCreate: function beforeCreate() {
    Geo.getLocCity();
  },
  mounted: function mounted() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Store.get('city_history').then(function () {
              var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
              _this2.history = res.slice(0, 6);
            }).catch(function (err) {
              console.warn(err);
            });
          case 2:
            Event.on('locationFail', function (res) {
              _this2.locationStatus = 1;
            });
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    handleCities: function handleCities() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var mtCities, cities;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getLionConfig('cities');
            case 2:
              mtCities = _context2.sent;
              // 许愿统一使用美团城市id列表
              cities = mtCities;
              _this3.cities = Object.freeze(mtCities);
              if (Array.isArray(cities)) {
                _context2.next = 7;
                break;
              }
              return _context2.abrupt("return");
            case 7:
              // 执行时间 少于10ms
              'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').forEach(function (letter) {
                var letterCities = cities.filter(function (c) {
                  if (!c || !c.py) return false;
                  var firstLetter = c.py.slice(0, 1);
                  return firstLetter.toLocaleUpperCase() === letter;
                });
                if (letterCities.length) {
                  _this3.cityLetterMap[letter] = letterCities;
                }
              });
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getLocation: function getLocation() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _Drip$constant2;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (isNaN(_this4.gCi)) {
                Geo.getLocCity().then(function (city) {
                  var cityId = city.cityId,
                    cityName = city.cityName;
                  _this4.locCity = {
                    nm: cityName,
                    id: cityId,
                    py: ''
                  };
                  // 许愿统一统计美团城市，点评需要将cityid转换成美团的
                  _this4.locationStatus = 3;
                }, function (fail) {
                  var _Drip$constant = Drip.constant,
                    cityId = _Drip$constant.cityId,
                    cityName = _Drip$constant.cityName;
                  _this4.locCity = {
                    nm: cityName,
                    id: cityId,
                    py: ''
                  };
                  _this4.locationStatus = 3;
                }).catch(function (err) {
                  console.warn(err);
                });
              } else {
                _this4.locCity = {
                  nm: '',
                  id: Number(_this4.gCi) === 0 ? Drip === null || Drip === void 0 ? void 0 : (_Drip$constant2 = Drip.constant) === null || _Drip$constant2 === void 0 ? void 0 : _Drip$constant2.cityId : _this4.gCi,
                  py: ''
                };
                _this4.locationStatus = 3;
              }
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    onTapAnchor: function onTapAnchor(event) {
      var target = event.target || event.currentTarget;
      // 自定义锚点
      if (!target) return;
      var anchor = target.dataset['anchor'];
      if (!anchor) return;
      var $anchor = document.getElementById(anchor);
      $anchor.scrollIntoView();
      event.stopPropagation();
    },
    onTapCity: function onTapCity(event) {
      var target = event.target || event.currentTarget;
      var _ref = target.dataset || {},
        id = _ref.id;
      // const letter = py.slice(0, 1).toLocaleUpperCase();
      if (id) {
        this.$emit('change', {
          id: id
        });
      }
    },
    handleClose: function handleClose() {
      this.$emit('change');
    }
  }
};